import React, { useEffect, useState } from "react";
import Layout from "../components/Layout";
import BgDotGrid from "../components/BgDotGrid";

const CATEGORIES = [
  "Communications, Media & Technology",
  "Financial Services",
  "Health & Life Sciences",
  "Products",
  "Resources",
  "Notebooks",
  "Other",
];

function FeaturedCard({ isNew, app_name, description, image, launch }) {
  return (
    <div className="mi-featured-card">
      {isNew && <span className="mi-featured-card-badge">NEW</span>}
      <div className="mi-featured-card-image">
        <img src={image} alt={app_name} />
      </div>
      <div className="mi-featured-card-body">
        <h6 className="mi-featured-card-title">{app_name}</h6>
        <p className="mi-featured-card-desc">{description}</p>
        {launch && (
          <a
            href={launch}
            target="_blank"
            rel="noopener noreferrer"
            className="mi-featured-card-btn"
          >
            Launch
          </a>
        )}
      </div>
    </div>
  );
}

function Home({ lightMode }) {
  const [appCount, setAppCount] = useState(0);
  const [featuredApps, setFeaturedApps] = useState([]);

  useEffect(() => {
    fetch("/apps/items")
      .then(r => r.json())
      .then(data => setAppCount(data.Count || 0))
      .catch(() => {});

    Promise.all(
      CATEGORIES.map(cat =>
        fetch(`/apps/industry/${encodeURIComponent(cat)}`)
          .then(r => r.json())
          .catch(() => ({ Items: [] }))
      )
    ).then(results => {
      const all = results.flatMap(r => r.Items || []);

      // Always pin "Deep QRBM" and "QPFAS" in the featured list
      const PINNED = ["Deep QRBM", "QPFAS"];
      const pinned = PINNED.map(name => all.find(a => a.app_name === name)).filter(Boolean);
      const rest = all.filter(a => !PINNED.includes(a.app_name));
      const newRest = rest.filter(a => a.isNew);
      const candidates = newRest.length >= 2 ? newRest : rest;
      const selected = [
        ...pinned,
        ...candidates.slice(0, 4 - pinned.length),
      ];

      setFeaturedApps(selected);
    });
  }, []);

  return (
    <Layout>
      <div className="mi-home-area">
        <BgDotGrid />
        <div className="mi-home-orb mi-home-orb--1" aria-hidden="true" />
        <div className="mi-home-orb mi-home-orb--2" aria-hidden="true" />

        {/* Hero */}
        <div className="mi-home-hero">
          <h1 className="mi-home-title">
            <span className="mi-home-brand">Quantum Hub</span>
          </h1>
          <p className="mi-home-subtitle">
            Accenture's platform showcasing quantum-enhanced offerings and
            capabilities across industries.{" "}
            <a href="https://in.accenture.com/quantum" className="gradient-link">
              Learn more →
            </a>
          </p>
          <div className="mi-home-stats">
            <div className="mi-home-stat">
              <span className="mi-stat-dot" />
              <span className="mi-home-stat-number">{appCount}</span>
              <span className="mi-stat-divider" />
              <span className="mi-home-stat-label">Live Demos</span>
            </div>
          </div>
        </div>

        {/* Featured Panel */}
        {featuredApps.length > 0 && (
          <div className="mi-home-panel">
            <div className="mi-home-panel-titlebar">
              <div className="mi-panel-dots">
                <span /><span /><span />
              </div>
              <div className="mi-panel-label">Featured Applications</div>
              <div className="mi-panel-dots-spacer" />
            </div>
            <div className="mi-home-panel-body">
              {featuredApps.map((app, i) => (
                <FeaturedCard key={i} {...app} />
              ))}
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
}

export default Home;
